<template>
  <div class="videoDirectorConfigRecorderEdit">
    <VideoRecorderConfiguration
      :installation-id="installationId"
      :config-id="configId"
      :lane-number="laneNumber"
    />
  </div>
</template>

<script>
export default {
  name: "VideoDirectorConfigRecorderEdit",
  components: {
    VideoRecorderConfiguration: () => import('@/components/Config/VideoDirector/VideoRecorderConfiguration.vue')
  },
  props: {
    installationId: {
      type: String,
      required: true
    },
    configId: {
      type: String,
      required: true
    },
    laneNumber: {
      type: String,
      required: false,
      default () {
        return null;
      }
    }
  },
  metaInfo () {
    return {
      title: 'Video Director Config'
    }
  }
}
</script>
